module.exports = __webpack_public_path__ + "img/camera.0b8a6bdd.svg";